const MIGRATION_LIST_CACHE_ID = 'MigrationList';

export {MIGRATION_LIST_CACHE_ID};
